/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetAccount200Response } from '../models';
/**
 * AccountApi - axios parameter creator
 * @export
 */
export const AccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 会社名をキーとしてアカウント詳細と紐づくリード一覧を取得するAPI
         * @summary アカウント詳細取得API
         * @param {string} key 会社名（URL エンコードされた文字列）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getAccount', 'key', key)
            const localVarPath = `/api/user/accounts/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 会社名をキーとしてアカウント詳細と紐づくリード一覧を取得するAPI
         * @summary アカウント詳細取得API
         * @param {string} key 会社名（URL エンコードされた文字列）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccount(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccount(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountApiFp(configuration)
    return {
        /**
         * 会社名をキーとしてアカウント詳細と紐づくリード一覧を取得するAPI
         * @summary アカウント詳細取得API
         * @param {string} key 会社名（URL エンコードされた文字列）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount(key: string, options?: any): AxiosPromise<GetAccount200Response> {
            return localVarFp.getAccount(key, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountApi - interface
 * @export
 * @interface AccountApi
 */
export interface AccountApiInterface {
    /**
     * 会社名をキーとしてアカウント詳細と紐づくリード一覧を取得するAPI
     * @summary アカウント詳細取得API
     * @param {string} key 会社名（URL エンコードされた文字列）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApiInterface
     */
    getAccount(key: string, options?: AxiosRequestConfig): AxiosPromise<GetAccount200Response>;

}

/**
 * Request parameters for getAccount operation in AccountApi.
 * @export
 * @interface AccountApiGetAccountRequest
 */
export interface AccountApiGetAccountRequest {
    /**
     * 会社名（URL エンコードされた文字列）
     * @type {string}
     * @memberof AccountApiGetAccount
     */
    readonly key: string
}

/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI implements AccountApiInterface {
    /**
     * 会社名をキーとしてアカウント詳細と紐づくリード一覧を取得するAPI
     * @summary アカウント詳細取得API
     * @param {AccountApiGetAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public getAccount(requestParameters: AccountApiGetAccountRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).getAccount(requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }
}
